import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import MainList from './main';
import { XTabNav } from '@/components/xqxc_ui';
import { ShowPort } from './types';
import { setBreadcrumbPaths } from '@/reducers/home/actions';
import { getSessionStorage, removeSessionStorage } from '@/assets/js/storage';
import { connect } from 'react-redux';

const tabList = [
    { id: ShowPort.USER_APP, label: '客户端' },
    { id: ShowPort.RIDER_APP, label: '骑手端' }
];

const Slide = (props) => {

    const [curTabID, setCurTabID] = useState(ShowPort.USER_APP);
    useEffect(() => {
        props.setBreadcrumbPaths(props.match); // 自动识别面包屑

        if (getSessionStorage('clientBaseSetSlideCurTabID')) {
            setCurTabID(getSessionStorage('clientBaseSetSlideCurTabID'));
            removeSessionStorage('clientBaseSetSlideCurTabID');
        }
    }, []);

    return (
        <div className={styles.flexBoxContainer}>
            <XTabNav renderData={tabList} onChange={setCurTabID} activedID={curTabID} />
            <MainList key={curTabID} curTabID={curTabID} {...props} />
        </div>
    );
};

Slide.propTypes = {
    match: PropTypes.object,
    history: PropTypes.object,
    setBreadcrumbPaths: PropTypes.func,
};

export default connect(null, { setBreadcrumbPaths })(Slide);